export function getRandomRange(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}